import React from 'react';
import { useHits, useInstantSearch } from 'react-instantsearch';
import ListingHit from './ListingHit';
import css from './Hits.module.css';


function CustomHits(props) {
  const { routeConfiguration, history, intl } = props;
  const { items, results, sendEvent } = useHits(props);
  const { status } = useInstantSearch();
  const queryID = results && results.queryID;

  if (status === 'loading') {
    return (
      <div className={css.loadingContainer}>
        <div className={css.loader}></div>
      </div>
    );
  }

  return (
    <>
      {!items.length ? (
        <div className={css.hitsContainer}>
          {intl.formatMessage({ id: 'AlgoliaSearchPage.noResults' })}
        </div>
      ) : (
        <ul className={css.hits}>
          {items.map(hit => (
            <li
              key={hit.objectID}
              onClick={() => sendEvent('click', hit, 'Hit Clicked')}
              onAuxClick={() => sendEvent('click', hit, 'Hit Clicked')}
            >
              <div style={{ wordBreak: 'break-all' }}>
                <ListingHit
                  hit={hit}
                  routeConfiguration={routeConfiguration}
                  history={history}
                  intl={intl}
                  queryID={queryID}
                />
              </div>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}

export default CustomHits;
